import { render, staticRenderFns } from "./StarterNavbar.vue?vue&type=template&id=04cfe392&scoped=true"
import script from "./StarterNavbar.vue?vue&type=script&lang=js"
export * from "./StarterNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cfe392",
  null
  
)

export default component.exports